"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This is a high order component that provides dynamic width calculation of
 * text input component based on their value/placeholder text string.
 *
 * @param {ReactElement} InputComponent - This is any React component that has an input ref.
 * @param {string} refProp: prop to get reference to `<input>`. Default is 'inputRef'
 * @returns {ReactElement} - react element.
 * @constructor
 */
function InputWidthProvider(InputComponent) {
  var refProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'inputRef';
  return (
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(_class2, _React$Component);

      function _class2(props) {
        var _this;

        _classCallCheck(this, _class2);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class2).call(this, props));

        _this.handleInputChange = function (event) {
          var onChange = _this.props.onChange;

          if (!_this.state.controlled) {
            _this.setState({
              sizerValue: event.currentTarget.value
            });
          }

          if (onChange) {
            onChange(event);
          }
        };

        var _this$props = _this.props,
            value = _this$props.value,
            defaultValue = _this$props.defaultValue;
        _this.state = {
          // Style for the sizer
          style: {},
          displayStyle: '',
          // Width for the sizer
          sizerWidth: 0,
          // If input is controlled or uncontrolled
          controlled: value || value === ''
        };

        if (_this.state.controlled) {
          _this.state.sizerValue = value;
        } else {
          _this.state.sizerValue = defaultValue;
        } // This is the dom ref to the `input` element which is used
        // to get the computed style.  See componentDidMount.


        _this.inputRef = props.inputRef || _react.default.createRef(); // Dom ref to the sizer div element.  This is used to
        // get the width to apply to the input.

        _this.sizerRef = _react.default.createRef();
        return _this;
      }
      /**
       * @override
       * @param {object} props - next Props
       * @param {object} state - previous state
       * @return {object|null} new state object or null
       */


      _createClass(_class2, [{
        key: "componentDidMount",

        /**
         * @override
         */
        value: function componentDidMount() {
          var element = this.inputRef.current;
          var style = window.getComputedStyle(element);
          var fontSize = style.fontSize,
              fontFamily = style.fontFamily,
              fontWeight = style.fontWeight,
              fontStyle = style.fontStyle,
              letterSpacing = style.letterSpacing,
              textTransform = style.textTransform,
              padding = style.padding,
              display = style.display; // eslint-disable-next-line react/no-did-mount-set-state

          this.setState({
            style: _objectSpread({}, this.state.style, {
              // List of css properties that can effect the width calculation.
              // eslint-disable-next-line object-property-newline
              fontSize: fontSize,
              fontFamily: fontFamily,
              fontWeight: fontWeight,
              fontStyle: fontStyle,
              letterSpacing: letterSpacing,
              textTransform: textTransform,
              padding: padding
            }),
            // Make sure display style for input is the same for the wrapper we create here so it
            // does not affect how components around it are rendered
            displayStyle: display
          });
        }
        /**
         * After the component has been rendered, here we calculate new input width if needed.
         * @override
         */

      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          var sizerEle = this.sizerRef.current; // TODO: 3 seemed to align correctly but not sure why.
          // TODO: Probably need to test this out on other browsers beside
          // Chrome.

          var currentWidth = sizerEle.scrollWidth + 3;

          if (currentWidth !== this.state.sizerWidth) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
              sizerWidth: currentWidth
            });
          }
        }
        /**
         * Handler for when value is change on the input element.
         * @param {ReactEvent} event - This is the input element event.
         */

      }, {
        key: "render",
        value: function render() {
          var _objectSpread2;

          // eslint-disable-next-line no-unused-vars
          var _this$props2 = this.props,
              onChange = _this$props2.onChange,
              style = _this$props2.style,
              props = _objectWithoutProperties(_this$props2, ["onChange", "style"]);

          var inputComponentProps = _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, refProp, this.inputRef), _defineProperty(_objectSpread2, "style", _objectSpread({}, style, {
            width: this.state.sizerWidth
          })), _defineProperty(_objectSpread2, "onChange", this.handleInputChange), _objectSpread2), props); // eslint-disable-next-line max-len


          var className = "".concat(_ThemeManager.default.getVar('classPrefix'), "-input-width-provider ").concat(_ThemeManager.default.getVar('classPrefix'));
          return _react.default.createElement("div", {
            className: className,
            style: {
              display: this.state.displayStyle || 'inline-block'
            }
          }, _react.default.createElement("div", {
            className: "hidden-sizer",
            ref: this.sizerRef,
            style: this.state.style
          }, _react.default.createElement("div", null, this.state.sizerValue), _react.default.createElement("div", null, this.props.placeholder)), _react.default.createElement(InputComponent, _extends({}, this.props, inputComponentProps)));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props, state) {
          if (state.controlled) {
            return _objectSpread({}, state, {
              sizerValue: props.value
            });
          }

          return null;
        }
      }]);

      return _class2;
    }(_react.default.Component)
  );
}
/**
 * @component
 */


var _default = InputWidthProvider;
exports.default = _default;